export default __webpack_public_path__ + "static/media/login-icon.e93315e1.svg";